function DiscussionBoard() {
  return <>DiscussionBoard</>;
}

export default DiscussionBoard;
